import client from './client';
import { ChatMessage, Conversation } from '../types';

export const chatApi = {
  sendMessage: (message: string, conversationId?: string, moduleContext?: string) =>
    client.post<{ message: ChatMessage; conversation_id: string }>('/chat/message', {
      message,
      conversation_id: conversationId,
      module_context: moduleContext,
    }),

  getConversations: () =>
    client.get<Conversation[]>('/chat/conversations'),

  getConversation: (id: string) =>
    client.get<Conversation>(`/chat/conversations/${id}`),
};
